import { Box, Checkbox, Text } from '@chakra-ui/react'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const Filter = () => {
    
    const [searchparams,setSearchparams] = useSearchParams()
    const initial = searchparams.getAll('category')
    const [category,setCategory] = useState(initial || [])

    const handlechange=(e)=>{
        const newCategory = [...category]
        if(newCategory.includes(e.target.value)){
            newCategory.splice(newCategory.indexOf(e.target.value),1)
        }
        else{
            newCategory.push(e.target.value)
        }
        setCategory(newCategory)
    }

    useEffect(()=>{
        let params={}
        params.category = category
        setSearchparams(params)
    },[category,setSearchparams])
  
  return (
    <div>
        <Box w='80%' margin='auto'>
              <Text fontWeight='medium' fontSize='2xl' align='left'>Sort out by Region :</Text>
            <Box display='flex' pt='10px' justifyContent='space-around'>
              <Checkbox value='SOUTH' onChange={handlechange} checked={category.includes('SOUTH')}>South</Checkbox>
              <Checkbox value='NORTH' onChange={handlechange} checked={category.includes('NORTH')}>North</Checkbox>
              <Checkbox value='EAST' onChange={handlechange} checked={category.includes('EAST')}>East</Checkbox>
              <Checkbox value='WEST' onChange={handlechange} checked={category.includes('WEST')}>West</Checkbox>
            </Box>
            </Box>
    </div>
  )
}

export default Filter